module.exports = __webpack_public_path__ + "components/signup/static/eye-slash-f08abe0db1dcc22ae7206d2efe7c4da6.svg";